<div class="settings-navigation" data-test="settings-navigation">
  <nav mat-tab-nav-bar color="accent" [tabPanel]="tabPanel" [mat-stretch-tabs]="false">
    <a mat-tab-link [routerLink]="['/settings', 'uom-setting']" [active]="isUomSetting$ | async">
      {{ 'settings.uom-setting' | translate }}
    </a>
    <a mat-tab-link [routerLink]="['/settings', 'barn']" [active]="isBarn$ | async">
      {{ 'settings.barns' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/settings', 'discount']"
      [active]="isDiscount$ | async"
      *ngIf="isAtLeastAdmin$ | async"
    >
      {{ 'settings.discounts' | translate }}
    </a>
    <a
      mat-tab-link
      [routerLink]="['/settings', 'dosator-setting']"
      [active]="isDosatorSetting$ | async"
    >
      {{ 'settings.dosator-settings' | translate }}
    </a>
  </nav>
  <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
</div>
